import React from 'react'
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { baseURL } from '../../../networkCalls';
const AboutUSCel = () => {
    return (
        <div className='container-fluid'>
            <div className='row d-flex align-items-center'>
                <div className='col-lg-1 col-md-1'>
                </div>
                <div className='col-lg-5 col-md-5'>
                    <h4 className='d-inline-block m-0 fw-bold text-uppercase'>
                        <span className='txtred'>About</span> <span className='txtdgray'>Us</span>
                    </h4>
                    <p className='f17 mt-3 mb-0'>India’s No. 1 Power Products company, Honda India Power Products Limited (HIPP) – formerly known as Honda Siel Power Products Ltd. (HSPP) – proudly celebrates its 40th anniversary of powering progress across the nation. A subsidiary of Honda Motor Co., Japan, HIPP was incorporated on 19th September 1985, and has since remained the undisputed leader in the power products industry.</p>
                    <p className='f17 mt-3'>Over the past four decades, HIPP has been at the forefront of innovation, manufacturing and marketing a trusted range of Portable Generators, Water Pumps, Tillers, and General Purpose Engines from its state-of-the-art facility in Greater Noida. The company also offers a premium lineup of Lawn Mowers, Brush Cutters, and Outboard Motors, catering to diverse customer needs across agriculture, construction, marine, and domestic sectors. As we mark this milestone, we thank our customers, partners, and stakeholders for being part of our incredible journey</p>
                    <div className='d-flex align-items-center text-center' >
                        <div className='flex-fill m-2 ms-0'>
                            <div className='bgsgray border p-2  pb-4'>
                                <div className='txtlgeay fw-bold f12'>
                                    <img src={require("./../../../assets/icons/hand-shake.png")} alt="" className='d-block m-auto pt-2 pb-2' style={{ width: '40px' }} />
                                    STRENGTH<br />500+ DEALERS
                                </div>
                            </div>
                        </div>
                        <div className='flex-fill m-2'>
                            <div className='bgsgray border p-2 pb-4'>
                                <div className='txtlgeay fw-bold f12'>
                                    <img src={require("./../../../assets/icons/customer.png")} alt="" className='d-block m-auto pt-2 pb-2' style={{ width: '40px' }} />
                                    CUSTOMERS<br /> 5 MILLION+
                                </div>
                            </div>
                        </div>
                        <div className='flex-fill m-2 me-0'>
                            <div className='bgsgray border p-2 pb-4'>
                                <div className='txtlgeay fw-bold f12'>
                                    <img src={require("./../../../assets/icons/coronavirus.png")} alt="" className='d-block m-auto pt-2 pb-2' style={{ width: '40px' }} />
                                    EXPORT<br /> 30 COUNTRIES
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-6 bgred vh-100 aboutbg d-none d-lg-block'>
                    {/* <LazyLoadImage
                        alt=""
                        effect="blur"
                        className='img-fluid w-25 mt-5 pt-5 ms-5'
                        src={`${baseURL}images/sbc.png`}
                    /> */}
                </div>
            </div>
        </div>
    )
}

export default React.memo(AboutUSCel)